import itemFullcont from "./item-fullcont.html";

const dialog = require('../../../../../components/dialog/dialog')
const fullcontEntity = require('../../../../../components/fullcont/fullcont-entity')
const fullcontHandler = require('../../../../../components/fullcont/fullcont-handler')
const itemDt = require('./item-dt')
const itemMenu = require('./item-menu')
const { formCopy } = require('./item-fullcont-form')
const { form } = require('./item-fullcont-form')
const { generateImage } = require('../../../../../components/avatar/avatar-generator')
const itemMT = undefined //no MT just add this like undefined
const handler = require('./item-fullcont-handler')
//Pause Inventory Update while the Item fullcont is visible and restore it after closing.
const inventoryUpdateFullcont = require('../inventoryUpdate/inventoryUpdate-fullcont')

const dtHandler = require('../../../../../components/dt/dt-handler')
const chart = require('./chart/item-quickview-chart')

/****************ELEMENTS*****************/
var htmlFc = {}
var HTMLwasSelected = false

function HTMLselect(detail) {

      fullcontHandler.HTMLselect(

            'item', //database table name****
            'item', //dest entity on js
            'item-fullcont',
            itemFullcont, form, formCopy, itemMT,
            editDialog, deleteDialog, dtCall, htmlFc)

      HTMLwasSelected = true
      handler.initDataFc(htmlFc)
      // htmlFc.hasFiles = true
      // fullcontHandler.rightsControl(htmlFc)
}/**/


export function start(detail) {

      if (!HTMLwasSelected) { HTMLselect(detail) }

      obj[detail.act].start(detail)
}/**/


const obj = {

      addOne: { start: (detail) => { addOne(detail, htmlFc) } },
      cancelEdit: { start: (detail) => { fullcontEntity.cancelEdit(detail, htmlFc) } },
      deleteEntity: { start: (detail) => { fullcontEntity.deleteEntity(detail, htmlFc) } },
      deleteFromDialog: { start: (detail) => { deleteFromDialog(detail, htmlFc) } },
      discard: { start: (detail) => { discard(detail, htmlFc) } },
      fullcontOptions: { start: (detail) => { itemMenu.start(detail, 'htmlDt', htmlFc) } },
      hide: { start: (detail) => { hide(detail, htmlFc) } },
      prepareAdd: { start: (detail) => { prepareAdd(detail, htmlFc) } },
      prepareEdit: { start: (detail) => { fullcontHandler.prepareEdit(detail, htmlFc) } },
      saveFromDialog: { start: (detail) => { fullcontEntity.saveFromDialog(detail, htmlFc) } },
      selectOne: { start: (detail) => { selectOne(detail, htmlFc) } },
      selectOneNoCheck: { start: (detail) => { selectOneNoCheck(detail, htmlFc) } },
      update: { start: (detail) => { fullcontEntity.update(detail, htmlFc) } },
      obtenerDatosTablaItemBehaivor: { start: (detail) => { obtenerDatosTablaItemBehaivor(detail) } },
      printReport: { start: (detail) => { handler.printReport(detail, htmlFc) } },

}/**/

function prepareAdd(detail) {
      const prepared = fullcontEntity.prepareAdd(detail, htmlFc, (response) => { getItemInformation(response, detail) })

      if(prepared){ inventoryUpdateFullcont.pauseForItem() }
}

function selectOne(detail, htmlFc) {
      const selected = fullcontEntity.selectOne(detail, htmlFc, processAfterSelectOne)

      if(selected){ inventoryUpdateFullcont.pauseForItem() }
}

function selectOneNoCheck(detail, htmlFc) {
      const selected = fullcontEntity.selectOneNoCheck(detail, htmlFc)

      if(selected){ inventoryUpdateFullcont.pauseForItem() }
}

function hide(detail, htmlFc) {
      const hidden = fullcontEntity.hide(detail, htmlFc)

      if(hidden){ resumeInventoryUpdate() }
}

function discard(detail, htmlFc) {
      fullcontHandler.discard(detail, htmlFc)
      resumeInventoryUpdate()
}

function resumeInventoryUpdate(attempt = 0) {
      setTimeout(()=>{
            const resumed = inventoryUpdateFullcont.resumeAfterItem()

            if(!resumed && attempt < 10){
                  resumeInventoryUpdate(attempt + 1)
            }
      }, 300)
}

function getItemInformation(htmlFc, detail) {
      handler.addDataDetail(detail,htmlFc);

      handler.getItemInformation(detail,htmlFc)
}

async function obtenerDatosTablaItemBehaivor(detail) {
      const rowAverage = htmlFc.fullcontHTML.querySelectorAll('.row-average');

      rowAverage.forEach(i => i.classList.add('dn'));

      const formData = new FormData();
      formData.append('idItem', detail.idItem);
      formData.append('from', detail.from);

      try {
            const response = await fetch("./server/php/queries/entityFunction/item_behaivor.php", {
                  method: "POST",
                  body: formData,
                  credentials: 'same-origin'
            });

            if (!response.ok) throw new Error(`Error en la red: ${response.status}`);

            const resultados = await response.json();

            if (resultados && resultados.data && resultados.data[0] !== null) {

                  rowAverage.forEach(i => i.classList.remove('dn'));

                  llenarCamposQuickView(resultados.data);
                  createChart(resultados.history);
            }

      } catch (err) {
            console.error("Error en la petición:", err);
      }
}

function llenarCamposQuickView(datos) {

      const columns = [
            { key: 'roi', label: 'ROI', format: 'percent', behavior: true },
            { key: 'speed', label: 'Speed', format: 'int', behavior: true },
            { key: 'friction', label: 'Sellability', format: 'int', behavior: true },
            { key: 'profit', label: 'Revenue', format: 'star', behavior: true },
            { key: 'perishable', label: 'Perishable', format: 'percent', behavior: true },
            { key: 'return_item', label: 'Return', format: 'percent', behavior: true }
      ];

      const html = dtHandler.dtSimpleFc(datos, columns);

      const cont = htmlFc.fullcontHTML.querySelector('#item-fullcont-behaivor');
      cont.innerHTML = ""
      cont.innerHTML = html

      return
}

function createChart(data) {
      chart.createChartFc(data);
}

export function resetFullcont(detail, htmlFc) {
      fullcontEntity.selectOne(detail, htmlFc)
}

//function to send
function editDialog() {
      dialog.start({ act: "show", id: "saveChanges", entity: 'item' })
}

function deleteDialog(detail) {
      dialog.start({ act: "show", dest: 'item', id: "deleteElem", entity: 'item', dbid: detail.dbid })
}

function dtCall(act, result) {
      itemDt.start({ act: act, row: result })
}

function addOne(detail, htmlFc) {

      fullcontEntity.addOne(detail, htmlFc)
      setTimeout(() => {

      }, 100)

      generateImage(detail, htmlFc)
}

function deleteFromDialog(detail, htmlFc) {

      fullcontEntity.deleteFromDialog(detail, htmlFc)
      setTimeout(() => {
            itemDt.start({ "dest": "item", "elem": "dt", "act": "select", "entity": "item" })
      }, 900)

      resumeInventoryUpdate()

}

function processAfterSelectOne(data, result) {
      handler.initChatsFc(data.chats)
}
